import ErpDashboardList from "./list";


if (document.body.getAttribute("data-current-path") === "erp/dashboard") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ErpDashboardList();
    }
}